module.exports = __webpack_public_path__ + "img/sharp-example4.4941d35c.jpg";